/**
 * Created by g8ukpm on 2/8/2018.
 */
import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], key: string, searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase() && searchText.toLowerCase().replace(/[ ]/g, '');
    return items.filter((it) => {
      if (it[key].toLowerCase() === searchText) {
        return true;
      } else if (
        searchText === 'due' &&
        (it[key].toLowerCase() === 'due' || it[key].toLowerCase() === 'duewarning')
      ) {
        return true;
      } else {
        return false;
      }
    });
  }
}
